/**
 * Created by rastwe on 3/1/2017.
 */
import {createStore, applyMiddleware} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension/developmentOnly';
import rootReducer from '../reducers';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import {
	isOnlineMiddleware,
	adMiddleware,
	//apiMiddleware,
	//idbMiddleware,
	workerMiddleware,
	authenticationMiddleware
} from '@ey/voltron-core';
import sidequestMiddleware from '../middlewares/sidequest-middleware';
import offlineMonitor from '../middlewares/offlinemonitor';
import tasklist from '../middlewares/tasklist-middleware';
import bookmark from '../middlewares/bookmark-middleware';
import tasklistUpdate from '../middlewares/tasklist-update-middleware';
//TODO: change update offline tasks to prepare offline tasks
import updateOfflineTasks from '../middlewares/updateOfflineTasks-middleware';
import docHelperMiddleware from '../middlewares/docHelper-middleware';
import offlineResponse from '../middlewares/offlineresponse';
import offlineSync from '../middlewares/offlinesync';
import syncUpdate from '../middlewares/sync-update';
import apiMiddleware from '../middlewares/api-middleware';
import _config from '../auth/config';
import idbMiddleware from '../middlewares/idb-middleware';
import offlineHandlers from '../middlewares/offlineHandlers';
import unBookmark from '../middlewares/unbookmark-middleware';
import versionCheck from '../middlewares/version-check';
import ceapDownloadMiddleware from '../middlewares/ceap-download-middleware';
import ceapUserMiddleware from '../middlewares/ceap-user-middleware';
import idleLogoutMiddleware from '../middlewares/idleLogout-middleware';
import loginContextMiddleware from '../middlewares/loginContext-middleware';
// import { uploadMiddleware } from '../middlewares/upload-middleware';
import {uploadMiddleware} from '@ey/voltron-doc-upload';
import {batchDownloadMiddleware, batchDownloadCompleteMiddleware} from '../middlewares/batch-download-middleware';
import env from '../util/env';
import envConfig from '@ey/voltron-config';
import {adobeAnalytics} from '@ey/voltron-analytics';

/**
 * Configures and creates a Redux store that includes all reducers and
 * the initial state of the application.
 * The devToolsExtension reference in the compose() call is the Chrome
 * implementation of the Redux development tool. Refer to:
 * https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd?hl=en
 * Note that the reduxImmutableStateInvariant middleware is needed only
 * in dev mode to prevent developers from modifying the state directly.
 * Doing so will produce an error.
 * Thunk is here to use for async operations like Ajax.
 * @param {Object} initialState - The initial state of your application.
 *      Particularly useful for server side rendering.
 * @return {*} A Redux Store instance
 */
export default function configureStore(initialState, config = _config) {
	return createStore(
		rootReducer,
		initialState,
		// Initiate redux dev tools
		composeWithDevTools(
			applyMiddleware(
				offlineSync(config),
				isOnlineMiddleware(config),
				offlineMonitor(config),
				ceapDownloadMiddleware(config),
				ceapUserMiddleware(config),
				idleLogoutMiddleware(config),
				loginContextMiddleware(config),
				adobeAnalytics.adobeAnalyticsMiddleware(envConfig.adobeAnalytics),
				sidequestMiddleware({
					map(action) {
						if (action.meta?.benefits) {
							return {
								type: 'BENEFITS',
								meta: {
									api: action.meta.benefits
								}
							};
						}
					}
				}),
				authenticationMiddleware(config),
				batchDownloadMiddleware(config),
				apiMiddleware(config),
				uploadMiddleware(env, {
					// These config options are used by the upchunk library: https://github.com/muxinc/upchunk
					chunkSize: 512, // KB
					retries: 3, // times
					delayBeforeRetry: 5 // seconds
				}),
				versionCheck(config),
				docHelperMiddleware(config),
				batchDownloadCompleteMiddleware(config),
				tasklist(config),
				updateOfflineTasks(config),
				bookmark(config),
				workerMiddleware(config),
				tasklistUpdate(config),
				unBookmark(config),
				idbMiddleware(config),
				offlineHandlers(config),
				offlineResponse(config),
				syncUpdate(config)
				//typeof window !== 'undefined' && reduxImmutableStateInvariant()
			)
		)
	);
}
